import React, { useState, useEffect, useRef } from 'react';
import { Button, Modal, Badge } from 'react-bootstrap';
import { Link } from "react-router-dom";
import Select from "react-select";
import DatePicker from "react-multi-date-picker";
import $ from 'jquery';
import axios from 'axios';

const SpecialCase = ({ show, onClose, itemCategoryIds, selectedpackage, onSave, oncancel }) => {

    const baseURL = process.env.REACT_APP_API_BASE_URL;

    const [selectedRows, setSelectedRows] = React.useState({});
    const [replaceSelections, setReplaceSelections] = React.useState({});
    const [itemsoption, setitemoptions] = React.useState([]);
    const [replaceitemopt, setReplace] = React.useState([]);
    const [checkedRows, setCheckedRows] = React.useState({});
    const [itemCounts, setItemCounts] = React.useState({});

    // Load item options (replaceitemopt filtered dynamically in checkbox handler)
    // useEffect(() => {
    //     if (itemCategoryIds.length > 0) {
    //         const postData = { category_ids: itemCategoryIds };
    //         axios.post(`${baseURL}/dropdown/items_by_categories`, postData)
    //             .then(response => {
    //                 const formatted = response.data.data.map(item => ({
    //                     value: item.sno,
    //                     label: item.name,
    //                 }));
    //                 setitemoptions(formatted);
    //                 setReplace(formatted);  // full list initially
    //             })
    //             .catch(error => console.log(error));
    //     }
    // }, [itemCategoryIds]);

    const [categoryOption, setCategory] = useState([]);
    const [selectedcategory, setselectedCategory] = useState([]);
    useEffect(() => {
        const fetchdata = async () => {
            try {
                const response = await axios.get(`${baseURL}/dropdown/get_health_issues`);
                const formatted = response.data.property.map(item => ({
                    value: item.sno,
                    label: item.property_name,
                }));
                setCategory(formatted);
            } catch (error) {
                console.log('Error fetching data', error);
            }
        };

        fetchdata();
    }, []);

    // new get method
    useEffect(() => {
        if (selectedpackage) {
            const postData = { product_id: selectedpackage.product, property_id: selectedcategory.join(",") };
            axios.get(`${baseURL}/specialcase`, { params: postData})
                .then(response => {
                    const formatted = response.data.data.items.map(item => ({
                        value: item.item_id,
                        label: item.item_name,
                    }));
                    setitemoptions(formatted);
                    // setReplace(formatted);  // full list initially
                })
                .catch(error => console.log(error));
            
            axios.get(`${baseURL}/specialcase_replace`, { params: postData})
                .then(response => {
                    const formattedreplace = response.data.data.items.map(item => ({
                        value: item.item_id,
                        label: item.item_name,
                    }));
                    setReplace(formattedreplace);
                })
                .catch(error => console.log(error));
        }
    }, [selectedpackage, selectedcategory]);

    const handleCheckboxChange = (id) => {
        setCheckedRows(prev => {
            const newChecked = { ...prev, [id]: !prev[id] };

            // If unchecking, reset selected radio, replace selection, and item count
            if (!newChecked[id]) {
                setSelectedRows(prev => {
                    const copy = { ...prev };
                    delete copy[id];
                    return copy;
                });
                setReplaceSelections(prev => {
                    const copy = { ...prev };
                    delete copy[id];
                    return copy;
                });
                setItemCounts(prev => {
                    const copy = { ...prev };
                    delete copy[id];
                    return copy;
                });
            } else {
                setSelectedRows((prevSelected) => ({
                    ...prevSelected,
                    [id]: 'Neglect',
                }));
            }

            return newChecked;
        });

        // Update replace item options for dropdown to exclude current item
        // setReplace(itemsoption.filter(item => item.value !== id));
    };

    const handleRadioChange = (id, value) => {
        handleCheckboxChange(id);
        setSelectedRows(prev => ({ ...prev, [id]: value }));
        if (value === "Replace") {
            setItemCounts(prev => ({ ...prev, [id]: 0 }));  // Reset count input for Replace
        } else if (value === "Neglect") {
            setReplaceSelections(prev => ({ ...prev, [id]: null }));  // Clear replace selection for Neglect
            setItemCounts(prev => ({ ...prev, [id]: 0 }));           // Optionally clear count
        }
    };

    const handleSelectChange = (id, option) => {
        setReplaceSelections(prev => ({ ...prev, [id]: option }));
    };

    const handleItemCountChange = (id, value) => {
        // Only allow positive integers (optional)
        const cleanValue = value === "" ? "" : Math.max(0, Number(value));
        setItemCounts(prev => ({ ...prev, [id]: cleanValue }));
    };

    const prepareSpecialCasePayload = () => {
        const special_case = Object.keys(checkedRows)
            .filter(id => checkedRows[id])  // only checked items
            .map(itemId => {
                const isReplace = selectedRows[itemId] === "Replace" ? 1 : 0;

                return {
                    item_id: Number(itemId),
                    item_name: itemsoption.find(i => i.value === Number(itemId))?.label || "",
                    is_replace: isReplace,
                    replace_item_id: isReplace ? (replaceSelections[itemId]?.value || 0) : 0,
                    replace_item_name: isReplace ? (replaceSelections[itemId]?.label || "") : "",
                    item_count: isReplace ? Number(itemCounts[itemId] || 0) : Number(itemCounts[itemId] || 0),  // count field required always, zero or value
                };
            });

        // Send this stringified payload to backend
        const jsonString = JSON.stringify(special_case);
        // console.log(jsonString);
        if (onSave) {
            onSave(jsonString);  // Send data back to parent
        }
        onClose();
    };


    const replacedItemIds = new Set(Object.values(replaceSelections).filter(Boolean).map(option => option.value));

    useEffect(() => {
        const replacedIds = new Set(
            Object.values(replaceSelections).filter(Boolean).map(o => o.value)
        );

        // Helper function to filter out replaced IDs from state
        const cleanState = (stateObj) => {
            let changed = false;
            const copy = { ...stateObj };
            Object.keys(copy).forEach(id => {
                if (replacedIds.has(Number(id))) {
                    delete copy[id];
                    changed = true;
                }
            });
            return changed ? copy : null;
        };

        setCheckedRows(prev => {
            const cleaned = cleanState(prev);
            return cleaned || prev;
        });

        setSelectedRows(prev => {
            const cleaned = cleanState(prev);
            return cleaned || prev;
        });

        setItemCounts(prev => {
            const cleaned = cleanState(prev);
            return cleaned || prev;
        });

        setReplaceSelections(prev => {
            const cleaned = cleanState(prev);
            return cleaned || prev;
        });

    }, [replaceSelections]);

    const handleCategoryChange = (selectedOptions) => {
        const values = selectedOptions ? selectedOptions.map(opt => opt.value) : [];
        setselectedCategory(values); // prevent null on clear
    };



    return (
        <Modal show={show} size="lg">
            <style>
                {`
          .table-container {
            max-height: 350px;
            overflow-y: auto;
            display: block;
          }

          .table-container table {
            border-collapse: collapse;
            width: 100%;
          }

          .table-container thead th {
            position: sticky;
            top: 0;
            background-color: #025D3A;
            z-index: 2;
          }
        `}
            </style>
            <div className="modal-content">
                <div className="modal-header" style={{ backgroundColor: '#3ab384' }}>
                    <h3 className="modal-title text-white">Special Case</h3>
                    <Button variant="" type="button" className="close px-6 py-2" data-dismiss="modal" onClick={oncancel}>
                        <span className="text-white">×</span>
                    </Button>
                </div>
                <div className="modal-body">
                    <div className="row mb-2">

                        <div className='col-lg-3 col-md-6 col-sm-12 d-flex flex-column mb-2'>
                            <label className='text-gray-800 font-w500 fs-7'>Product</label>
                            <label className='text-danger fs-6 font-w500'>{selectedpackage.name}</label>
                        </div>
                        <div className='col-lg-3 col-md-6 col-sm-12 d-flex flex-column mb-2'>
                            <label className='text-gray-800 font-w500 fs-7'>Timeline</label>
                            <label className='text-danger fs-6 font-w500'>{selectedpackage.timeline_name} ({selectedpackage.days_count} Days)</label>
                        </div>
                        <div className='col-lg-6 col-md-6 col-sm-12 d-flex flex-column mb-2'>
                            <label className='text-gray-800 font-w600 fs-7'>Special Case Category</label>
                            <Select placeholder="Select Replaced Item"
                                options={categoryOption}
                                isMulti
                                menuPortalTarget={document.body}
                                styles={{ menuPortal: (base) => ({ ...base, zIndex: 9999 }) }}
                                onChange={handleCategoryChange}
                            />
                        </div>
                    </div>
                    <div className='row'>
                        <div className='col-lg-12 mb-4'>
                            <div className="table-container">
                                <table className="table align-top table-row-dashed table-striped table-hover fs-7 gy-1 gs-2 dataTable">
                                    <thead>
                                        <tr className="text-start text-muted fw-bold fs-6 gs-0 th_head align-top">
                                            <th className="min-w-100px text-start">Menu List</th>
                                            <th className="min-w-100px text-start">Replace / Neglect</th>
                                        </tr>
                                    </thead>
                                    <tbody className="text-gray-600 fw-semibold fs-7 align-top">

                                        {itemsoption.filter(item => !replacedItemIds.has(item.value)).map((item, rowIndex) => (
                                            <tr key={rowIndex}>
                                                {/* <td>
                                                    <input
                                                        className="form-check-input me-2"
                                                        type="checkbox"
                                                        checked={!!checkedRows[item.value]}
                                                        onChange={() => handleCheckboxChange(item.value)}
                                                    />
                                                </td> */}
                                                <td>
                                                    <label className="fw-semibold text-black fs-6">{item.label}</label>
                                                </td>
                                                <td>
                                                    <div className="mt-2">
                                                        <div className="form-check-inline">
                                                            <input
                                                                className="form-check-input"
                                                                type="radio"
                                                                name={`replace_neglect_${item.value}`}
                                                                value="Replace"
                                                                checked={selectedRows[item.value] === "Replace"}
                                                                onChange={(e) => handleRadioChange(item.value, e.target.value)}
                                                            // disabled={!checkedRows[item.value]}
                                                            />
                                                            <label className="form-check-label fs-7">Replace</label>
                                                        </div>
                                                        <div className="form-check-inline">
                                                            <input
                                                                className="form-check-input"
                                                                type="radio"
                                                                name={`replace_neglect_${item.value}`}
                                                                value="Neglect"
                                                                checked={selectedRows[item.value] === "Neglect"}
                                                                onChange={(e) => handleRadioChange(item.value, e.target.value)}
                                                            // disabled={!checkedRows[item.value]}
                                                            />
                                                            <label className="form-check-label fs-7">Neglect</label>
                                                        </div>
                                                    </div>

                                                    {/* Show dropdown and count input if Replace selected */}
                                                    {selectedRows[item.value] === "Replace" && (
                                                        <div className="d-flex mt-2" style={{ gap: "1rem" }}>
                                                            <div style={{ flex: 1 }}>
                                                                <Select
                                                                    placeholder="Select Replaced Item"
                                                                    value={replaceSelections[item.value] || null}
                                                                    onChange={(option) => handleSelectChange(item.value, option)}
                                                                    options={replaceitemopt}
                                                                    menuPortalTarget={document.body}
                                                                    styles={{ menuPortal: (base) => ({ ...base, zIndex: 9999 }) }}
                                                                // isDisabled={!checkedRows[item.value]}
                                                                />
                                                            </div>
                                                            <div style={{ width: "150px" }}>
                                                                <input
                                                                    type="number"
                                                                    className="form-control"
                                                                    placeholder="Enter Item Count"
                                                                    // disabled={!checkedRows[item.value]}
                                                                    value={itemCounts[item.value] || ""}
                                                                    min={0}
                                                                    onChange={(e) => handleItemCountChange(item.value, e.target.value)}
                                                                />
                                                            </div>
                                                        </div>
                                                    )}
                                                </td>
                                            </tr>
                                        ))}

                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                    <div className="d-flex align-items-center justify-content-center gap-3 mt-4">
                        <button className="btn btn-sm btn-secondary" onClick={oncancel}>Cancel</button>
                        <button className="btn btn-sm btn-primary" onClick={prepareSpecialCasePayload}>Update Special Case</button>
                    </div>
                </div>
            </div>
        </Modal>
    );
};

export default SpecialCase;
